import Box from 'UIKit/Box/Box'
import { howlMapper } from 'config/constants/audio'
import { InhouseGameDetails } from 'config/types/game'
import React, { useEffect, useState } from 'react'
import { StyledInhouseGameContainer } from '../components/styled'
import { GameInHouseConfig } from '../config/types'
import PlinkoBetSettings from './components/BetBoard/PlinkoBetSettings'
import GameBoard from './components/GameBoard'
import Loader from './components/GameBoard/components/Loader'
import { Risk, risks, rows } from './components/GameBoard/config'
import { useInhouseSession, useLoadCdnPartyPlinko } from './hooks'

const PlinkoGame: React.FC<GameInHouseConfig & { game: InhouseGameDetails }> = ({ volumeEnable, game, ...config }) => {
  const [row, setRow] = useState(rows[rows.length - 1].value)
  const [risk, setRisk] = useState<Risk>(risks[2].value)

  const { gameSettings } = useInhouseSession({
    game,
  })

  useEffect(() => {
    // Init audio
    // eslint-disable-next-line no-unused-expressions
    howlMapper.PlinkoCompleted
  }, [])

  const loaded = useLoadCdnPartyPlinko()

  return (
    <StyledInhouseGameContainer>
      <PlinkoBetSettings
        row={row}
        onSelectRow={setRow}
        risk={risk}
        onSelectRisk={setRisk}
        volumeEnable={volumeEnable}
        game={game}
        gameSettings={gameSettings}
        {...config}
        width="100%"
        mt={['16px', '', '', '', '0']}
      />
      {loaded ? (
        <GameBoard volumeEnable={volumeEnable} row={row} risk={risk} game={game} />
      ) : (
        <Box position="relative" width="100%" height="100%">
          <Loader isFinished={false} />
        </Box>
      )}
    </StyledInhouseGameContainer>
  )
}

const PlinkoGameMemorized = React.memo(PlinkoGame)

export default PlinkoGameMemorized
